<template>
  <v-card class="mx-auto mt-n3" v-if="!loader">
    <v-img
      :src="require('../../assets/images/banners/mlcp.jpg')"
      class="my-3"
      contain
    />
    <v-card-title
      class="justify-center text-uppercase page-title"
      :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
    >
      Parking At Chennai Airport
    </v-card-title>
    <v-card-subtitle
      class="text-center page-sub-title"
      :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
    >
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
        MLCP Parking Charges
      </h1>
    </v-card-subtitle>

    <v-container>
      <v-row
        v-scrollanimation
        align="center"
        justify="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col cols="12">
          <v-data-table
            :headers="parking.headers"
            :items="parking.data"
            hide-default-footer
            class="elevation-1 mb-5 ml-1 mr-1 custom-table custom-table-mlccchg"
            :items-per-page="-1"
          ></v-data-table>
        </v-col>
      </v-row>
      <v-row
        dense
        v-scrollanimation
        align="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col
          class="px-3 mt-5"
          v-for="(commercial, i) in parking.commercials"
          :key="i"
          cols="12"
          md="3"
          sm="6"
        >
          <v-card flat class="mb-15 ma-2" height="auto" width="100%">
            <div
              :class="{
                'headingBox-txt-mobile': $vuetify.breakpoint.smAndDown,
              }"
              class="headingBox-txt"
            >
              <h2>{{ commercial.header }}</h2>
              <p class="mt-5">{{ commercial.content }}</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import config from "../../config";
import api from "../../api";
export default {
  name: "MLCP",
  data() {
    return {
      url: config.airport.url,
      parking: {
        headers: [
          {
            text: "Time Duration",
            align: "center",
            sortable: false,
            value: "duration",
          },
          {
            text: "Two Wheeler",
            align: "center",
            value: "twowheeler",
          },
          {
            text: "Cars",
            align: "center",
            value: "cars",
          },
          {
            text: "Tempo /  Bus / Truck < 16 Seater",
            align: "center",
            value: "lessthan16seater",
          },
          {
            text: "Tempo /  Bus / Truck > 16 Seater",
            align: "center",
            value: "morethan16seater",
          },
        ],
        data: [
          {
            duration: "Upto 30 mins",
            twowheeler: "20",
            cars: "85",
            lessthan16seater: "330",
            morethan16seater: "660",
          },
          {
            duration: "30 mins to 1 hr",
            twowheeler: "20",
            cars: "110",
            lessthan16seater: "330",
            morethan16seater: "660",
          },
          {
            duration: "1 hr to 2 hrs",
            twowheeler: "35",
            cars: "165",
            lessthan16seater: "330",
            morethan16seater: "660",
          },
          {
            duration: "2 hrs to 3 hrs",
            twowheeler: "45",
            cars: "220",
            lessthan16seater: "415",
            morethan16seater: "825",
          },
          {
            duration: "3 hrs to 4 hrs",
            twowheeler: "55",
            cars: "275",
            lessthan16seater: "495",
            morethan16seater: "990",
          },
          {
            duration: "4 hrs to 5 hrs",
            twowheeler: "60",
            cars: "310",
            lessthan16seater: "580",
            morethan16seater: "1160",
          },
          {
            duration: "5 hrs to 6 hrs",
            twowheeler: "65",
            cars: "340",
            lessthan16seater: "660",
            morethan16seater: "1325",
          },
          {
            duration: "6 hrs to 7 hrs",
            twowheeler: "70",
            cars: "375",
            lessthan16seater: "745",
            morethan16seater: "1490",
          },
          {
            duration: "7 hrs to 8 hrs",
            twowheeler: "75",
            cars: "410",
            lessthan16seater: "825",
            morethan16seater: "1655",
          },
          {
            duration: "8 hrs to 9 hrs",
            twowheeler: "85",
            cars: "440",
            lessthan16seater: "910",
            morethan16seater: "1820",
          },
          {
            duration: "9 hrs to 10 hrs",
            twowheeler: "90",
            cars: "475",
            lessthan16seater: "990",
            morethan16seater: "1985",
          },
          {
            duration: "10 hrs to 24 hrs",
            twowheeler: "100",
            cars: "550",
            lessthan16seater: "1100",
            morethan16seater: "2205",
          },
          {
            duration: "Day 2 onwards or part there of",
            twowheeler: "45 for each day",
            cars: "330 for each day",
            lessthan16seater: "880 for each day",
            morethan16seater: "1100 for each day",
          },
        ],
        commercials: [
          {
            header: "Commercial Vehicle",
            content:
              "Radio taxi/APP taxi/ Commercial Vehicle /Pre-paid taxi - Rs.45 per entry for pickup",
          },
          {
            header: "Valet Car Parking Service",
            content: "Rs.165 Plus actual parking charges",
          },
          {
            header: "Loss of Parking Ticket for Car & Buses",
            content: "Rs.550 plus actual parking charges for Car & Buses.",
          },
          {
            header: "Loss of Parking Ticket for Two Wheelers",
            content: "Rs. 165 plus actual parking charges for Two Wheelers",
          },
        ],
      },
    };
  },
  computed: {
    current: {
      get() {
        return this.$store.getters.current;
      },
    },
    loader: {
      get() {
        return this.$store.getters.loader;
      },
    },
  },
  methods: {},
  async mounted() {},
};
</script>
<style scoped>
.mlcptext {
  width: 90%;
}
.headingBox-txt h2 {
  font-size: 22px;
}

.headingBox-txt p {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #6b7280;
  height: 80px;
}

.headingBox-txt-mobile p {
  height: 60px;
}
.headingBox-txt {
  box-shadow: rgba(16, 24, 40, 0.2) 0px 25px 50px -1px;
  padding: 15px 15px 15px 15px;
}
</style>
